.container {
    width: 100%;
    /*padding: 0 2rem;*/
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
}

.pageContainer {
    /* padding: 2.25rem 2rem; */
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.salesLineChart {
    grid-column: span 4;
    height: fit-content;
}

.salesBarChart {
    grid-column: span 2;
    height: 447px;
}

.smallerChartsGrid {
    grid-column: span 2;
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
}

.smallChart {
    grid-column: span 1;
}

.topRowContainer {
    display: flex;
    justify-content: space-between;
    width: 100%;

}

.topRowButtons {
    display: flex
}

.headerSection {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 50%;
    overflow: hidden;
}

.backButton {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: inherit;
    flex-shrink: 0;
}

.productNameLink {
    text-decoration: none;
    color: inherit;
}

.selectionRender {
    display: flex;
    align-items: center;
    gap: 0.375rem;
}

.title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
}

.productImage {
    width: 60px;
    height: 60px;
    object-fit: cover;
    object-position: center;
    border-radius: 4px;
    border: 1px solid var(--static-divider-standard);
    padding: 8px;
    background: var(--static-background-strong);
}

.productInfo {
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow: hidden;
}

.productName {
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}


.productDetail {
    display: flex;
    align-items: center;
    gap: 4px;
}

